import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { resetNCState } from "../../nav-control/redux/actions/index";

const useNavTabBar = (action) => {
  let globalHistory = useHistory();
  const storeHistory = useSelector(state => state.storeHistory);
  const dispatch = useDispatch();

  const { history, prev, next } = storeHistory;
  let active = false;
  let onClick = null;
  switch(action) {
    case 'previous':
      active = (history && history.findIndex(x => x.active) > 0)
      onClick = () => {
        prev(globalHistory);
        dispatch(resetNCState()); // Nav Control Module
      }
      break;
    case 'next':
      active = (history && history.findIndex(x => x.active) < history.length - 1);
      onClick = () => {
        next(globalHistory);
        dispatch(resetNCState()); // Nav Control Module
      }
      break;
    default:
  }

  return { active, onClick };
};

export default useNavTabBar;
